import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import Popup from '../Popup';
import { Dim } from '../../../constants/components';
import {
    DEFAULT_FONT_SIZE_SCALE,
    MAXIMUM_FONT_SIZE_SCALE,
    SCALE_STEP
} from '../../../constants/accessibility';
import { ApolloContext } from '../../../ApolloContextProvider';

// TODO cover with unit tests
const AccessibilitySettingsPopup = ({
    hideSettingsPopup,
}) => {
    const { setAccessibilityConfigValues, accessibilityConfigLoading, fontSizeScaleValue } = useContext(ApolloContext);

    const [accessibilityFontSize, setAccessibilityFontSize] = useState(fontSizeScaleValue);
    const onFontSizeChange = e => {
        // Range slider e.target.value returns string
        setAccessibilityFontSize( Number(e.target.value));
    };
    const decrementFontSize = () => {
        if (accessibilityFontSize > DEFAULT_FONT_SIZE_SCALE) {
            setAccessibilityFontSize(accessibilityFontSize - SCALE_STEP);
        }
    };
    const incrementFontSize = () => {
        if (accessibilityFontSize < MAXIMUM_FONT_SIZE_SCALE) {
            setAccessibilityFontSize(accessibilityFontSize + SCALE_STEP);
        }
    };
    const onSaveClick = () => {
        setAccessibilityConfigValues({ fontSizeScaleValue: parseFloat(accessibilityFontSize) }, hideSettingsPopup);
        setAccessibilityFontSize(accessibilityFontSize);

    };
    const onCancelClick = () => {
        hideSettingsPopup();
    };
    return (
        <div className="settings-popup">
            <Popup backgroundDim={Dim.FULL}>
                <div className="modal-table">
                    <h2 className="settings-header">Maze Text Size</h2>
                    <div className="settings-content">
                        <div className="font-size-range-container">
                            <div className="font-size-range">
                                <button onClick={decrementFontSize} className="decrement-font">A</button>
                                <input
                                    value={accessibilityFontSize}
                                    aria-label="Font size range"
                                    onChange={onFontSizeChange}
                                    type="range"
                                    min={DEFAULT_FONT_SIZE_SCALE}
                                    max={MAXIMUM_FONT_SIZE_SCALE}
                                    step={SCALE_STEP}
                                />
                                <button onClick={incrementFontSize} className="increment-font">A</button>
                            </div>
                        </div>
                        <div className={`preview-font-size-${accessibilityFontSize} settings-example-content`}>
                            <p>Soccer is a hard game. You do plenty of fast running and dodging when you play it. Kicking the ball takes strength and lots of mental focus. </p>
                        </div>
                    </div>
                    <button
                        aria-label="Cancel button"
                        className="popup-button round-button white"
                        onClick={onCancelClick}
                        disabled={accessibilityConfigLoading}
                    >
                        Cancel
                    </button>
                    <button
                        aria-label="Save button"
                        className="popup-button round-button green"
                        onClick={onSaveClick}
                        disabled={accessibilityConfigLoading || accessibilityFontSize === fontSizeScaleValue}
                    >
                        Save
                    </button>
                </div>
            </Popup>
        </div>
    );
};

AccessibilitySettingsPopup.propTypes = {
    hideSettingsPopup: PropTypes.func,
};

AccessibilitySettingsPopup.defaultProps = {
    hideSettingsPopup: () => { },
};

export default AccessibilitySettingsPopup;
